// removed by extract-text-webpack-plugin
module.exports = {"col":"_32HD_","icon-container":"Oe_WR","update":"_3eB_D","thank":"zBXId","milestone":"_3xSLP","icon":"_3HL8z","title":"_1kPNL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RichUpdates/RichUpdatesCreator/RichUpdatesCreatorLink.scss
// module id = ./src/components/RichUpdates/RichUpdatesCreator/RichUpdatesCreatorLink.scss
// module chunks = 4